import { render, staticRenderFns } from "./SalaryMonthSelector.vue?vue&type=template&id=276d67e8&"
import script from "./SalaryMonthSelector.vue?vue&type=script&lang=ts&"
export * from "./SalaryMonthSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports